<template>
  <div class="battery-status">
    <div class="battery-status__item">
      <img src="../../assets/img/ico-status-battery.svg" alt="battery icon" />
      <div class="bigValue">
        <span v-if="!batteryCalculatedSoC || isNaN(batteryCalculatedSoC)">--</span>
        <span class="value" v-else
          >{{ $n(batteryCalculatedSoC) }}<span class="unit">kWh</span></span
        >
      </div>
      <div class="smallValue">
        {{ $t('Web.System.TotalCapacity') }}
        <span v-if="!batteryCapacitySum">(-- kWh)</span>
        <span v-else>({{ $n(batteryCapacitySum) }}kWh)</span>
      </div>
    </div>

    <div class="battery-status__item">
      <img src="../../assets/img/ico-status-lifecycle.svg" alt="lifecycle icon" />
      <div class="bigValue">
        <span>{{ batteryCycles }}</span>
      </div>
      <div class="smallValue">{{ $t('Web.System.Cycles') }}</div>
    </div>
  </div>
</template>

<script>
const DEFAULT_BATTERY_CHARGE = 3.3;

export default {
  name: 'BatteryStatus',
  props: {
    managerApp: {
      type: Object,
      default: () => {}
    },
    batteryData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    batteryCapacity() {
      return ((this.managerApp || {}).parameters || {}).App_Bat_Module_Capacity || 0;
    },
    batteryCapacitySum() {
      return this.batteryModules * DEFAULT_BATTERY_CHARGE;
    },
    batteryModules() {
      return ((this.batteryData || {}).parameters || {}).Number_of_Modules || 0;
    },
    batteryCalculatedSoC() {
      return (
        this.calculateSOCQL(this.batteryModules, this.batteryCapacity, this.batterySOC) || '--'
      );
    },
    batterySOC() {
      return ((this.batteryData || {}).parameters || {}).LG_Battery_SOC || '--';
    },
    batteryCycles() {
      return ((this.batteryData || {}).parameters || {}).Battery_Module1_Cycles || '--';
    }
  },
  methods: {
    calculateSOCQL(batteries, capacity, batPercentage) {
      const maxCapacityWh = batteries * capacity;
      const capacityWh = (maxCapacityWh * batPercentage) / 100;

      return (capacityWh / 1000).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.battery-status {
  border-radius: 8px;
  background-color: hsla(0, 0%, 100%, 0.6);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: 0.5px solid $cloudy-blue;
  display: flex;
  justify-content: center;
  min-height: 104px;
  height: 104px;
  width: $maxWidth;

  &__item {
    flex: 0 0 50%;
    box-shadow: inset 1px 0 0 0 $cloudy-blue;
    text-align: center;

    &:first-child {
      box-shadow: none;
    }

    img {
      margin-top: 14px;
    }

    .bigValue {
      @include valueSmall;
      color: $charcoal-grey;
      margin-bottom: 3px;

      .unit {
        @include textSmall;
        color: inherit;
      }
    }

    .smallValue {
      @include textSmall;
      color: $bluey-grey;
    }
  }
}
</style>
